let red = '#E3170A';
let orange = '#ECA400';
let green = '#00B9AF';
let blue = '#534BAE';

let brand = {
  light: '#534BAE',
  light2: '#534BAE',
  base: '#1A237E',
  accent: '#00B9AF',
};

export const grey = {
  lighter: '#faf9f8',
  light: '#F4F6F8',
  base: '#E1DFDD',
  dark: '#C8C6C5',
  n10: '#faf9f8',
  n20: '#f3f2f1',
  n30: '#edebeb',
  n40: '#e1dfdd',
  n60: '#c8c6c4',
  n80: '#b3b0ad',
  n100: '#979593',
  n120: '#797775',
  n140: '#484644',
  n160: '#323130',
  n180: '#252423',
};

// OGL Colors
// purple #452668
// blue #534BAE

const theme = {
  colors: {
    brandAccent: '#00B9AF',
    brandPrimary: '#1A237E',
    brandLight: '#534BAE',
    grey10: grey.n10,
    grey20: grey.n20,
    grey30: grey.n30,
    grey40: grey.n40,
    grey60: grey.n60,
    grey80: grey.n80,
    grey100: grey.n100,
    grey120: grey.n120,
    grey140: grey.n140,
    grey160: grey.n160,
    appHeader: grey.light,
    appPrimary: '#bdbdbd',
    appPrimaryDark: '#616161',
    appPrimaryLight: '#f5f5f5',
    appContentBackground: '#ffffff',
    filteredItems: '#ffa000',
    inputLabel: '#212B36',
    inputCardHeading: '#212B36',
    inputControl: '#000',
    inputBorder: '#ccc',
    inputBorderHover: '#534BAE',
    inputBorderError: '#ffa000',
    inputErrorMessage: '#ffa000',
    requiredIcon: '#ffa000',
    hintIcon: '#00b9af',
    switchOnBg: '#534BAE',
    switchOnCircle: '#534BAE',
    switchOffCircle: '#e5e5e5',
    checkboxChecked: '#534BAE',
    formHeading: '#797775',

    /**
     * @deprecated - Use p4Tokens.statusFlagDanger
     */
    notificationError: '#E3170A',

    /**
     * @deprecated - Use p4Tokens.statusFlagInfo
     */
    notificationInfo: '#00B9AF',
    // This is here to style the notification icons under "Recent Notifications" to match the new colour of the
    // fluent UI info toasts. The old notificationInfo has been left as it is (teal) as this is used for multiple
    // other elements throughout P4.
    notificationInfoFluentDefault: '#424242',

    /**
     * @deprecated - Use p4Tokens.statusFlagSuccess
     */
    notificationSuccess: '#4caf50',
    notificationTitle: '#424242',
    notificationText: '#484644',

    /**
     * @deprecated - Use p4Tokens.statusFlagWarning
     */
    notificationWarning: '#ffa000',

    /**
     * @deprecated - Use p4Tokens.statusFlagBasic
     */
    notificationDefault: '#bdbdbd',
    tooltipText: '#ffffff',
    tooltipBackground: '#534BAE',
  },

  buttons: {
    default: {
      text: '#212B36',
      border: grey.base,
      background: '#ffffff',
      hoverText: '#212B36',
      hoverBorder: grey.dark,
      hoverBackground: grey.dark,
    },
    primary: {
      text: '#ffffff',
      border: '#534BAE',
      background: '#534BAE',
      hoverText: '#ffffff',
      hoverBorder: '#1A237E',
      hoverBackground: '#1A237E',
    },
    success: {
      text: '#ffffff',
      border: '#00B9AF',
      background: '#00B9AF',
      hoverText: '#ffffff',
      hoverBorder: '#019e96',
      hoverBackground: '#019e96',
    },
    info: {
      text: '#212B36',
      border: grey.base,
      background: grey.base,
      hoverText: '#212B36',
      hoverBorder: grey.dark,
      hoverBackground: grey.dark,
    },
    secondary: {
      text: '#212B36',
      border: grey.base,
      background: '#ffffff',
      hoverText: '#ffffff',
      hoverBorder: grey.dark,
      hoverBackground: grey.dark,
    },
    warning: {
      text: '#ffffff',
      border: '#ECA400',
      background: '#ECA400',
      hoverText: '#ffffff',
      hoverBorder: '#DE7F1B',
      hoverBackground: '#DE7F1B',
    },
    danger: {
      text: '#212B36',
      border: '#E0E0E0',
      background: '#ffffff',
      hoverText: '#ffffff',
      hoverBorder: '#E3170A',
      hoverBackground: '#E3170A',
    },
    borderLess: {
      text: '#212B36',
      border: '#ffffff',
      background: '#ffffff',
      hoverText: '#ffffff',
      hoverBorder: '#ffffff',
      hoverBackground: '#534BAE',
    },
    link: {
      text: '#534BAE',
      border: 'transparent',
      background: 'transparent',
      hoverText: '#1A237E',
      hoverBorder: 'transparent',
      hoverBackground: 'transparent',
    },
  },
  grid: {
    gutterWidth: '16px',
    negGutterWidth: '-16px',
  },
  breakpoints: {
    mobile: 0,
    tablet: 797,
    desktop: 1025,
  },
};

export default theme;
